import React, { useEffect, useState } from "react";
import "./Orders.css"; 

function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem("orders_history"); 
    if (saved) {
      setOrders(JSON.parse(saved).reverse());
    }
  }, []);

  return (
    <div className="orders-container">
      <h2 className="page-title">My Orders</h2>
      {orders.length === 0 ? (
        <div className="no-orders">
          <p>No orders found.</p>
          <button className="shop-now-btn" onClick={() => window.location.href="/"}>Start Shopping</button>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map(order => (
            <div key={order.id} className="order-card">
              {/* --- Order Header (Grey Strip) --- */}
              <div className="order-header">
                <div className="header-column">
                  <p className="label">ORDER PLACED</p>
                  <p className="val">{order.date || "N/A"}</p>
                </div>
                <div className="header-column">
                  <p className="label">TOTAL</p>
                  <p className="val">₹{order.total}</p>
                </div>
                <div className="header-column desktop-only">
                  <p className="label">ORDER ID</p>
                  <p className="val">#{order.id?.slice(-8).toUpperCase()}</p>
                </div>
                <div className="header-column">
                   <span className={`status-badge ${order.status?.toLowerCase() || 'processing'}`}>
                    {order.status || "Processing"}
                   </span>
                </div>
              </div>

              {/* --- Order Items Section --- */}
              <div className="order-items">
                {order.line_items && order.line_items.map((item, index) => (
                  <div key={index} className="order-item-row">
                    <img 
                      src={item.image || (item.images && item.images[0]?.src) || "https://via.placeholder.com/50"} 
                      alt={item.name} 
                      className="order-item-img" 
                    />
                    <div className="item-info">
                      <p>{item.name}</p>
                      <span>Qty: {item.quantity || item.qty}</span>
                    </div>
                  </div>
                ))}
                {(!order.line_items || order.line_items.length === 0) && (
                   <p className="no-items-text">Order details processed successfully.</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Orders;